const searchProducts = (searchTerm) => {
	const url = `/search/suggest.json?q=${searchTerm}&resources[type]=product`;
	return fetch(url, {
		crossDomain: true,
		credentials: 'same-origin',
	})
		.then((response) => {
			if (!response.ok) {
				throw Error(response.statusText);
			}
			return response.json();
		})
		.catch((error) => {
			console.error(error);
		});
};

export { searchProducts };
